import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'

import * as utils from './utils'
Vue.prototype.$utils = utils;

import CargandoInfo from '@/views/utils/CargandoInfo.vue'
Vue.component(CargandoInfo.name, CargandoInfo)


import VueCookie from 'vue-cookie'

Vue.use(VueCookie)

import VModal from 'vue-js-modal'
Vue.use(VModal)

import VueNotification from "@kugatsu/vuenotification";
Vue.use(VueNotification);

import 'vue-search-select/dist/VueSearchSelect.css'


import VueCurrencyFilter from 'vue-currency-filter'
Vue.use(VueCurrencyFilter, [
  {
    symbol : '$',
    thousandsSeparator: '.',
    fractionCount: 0,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: false,
    avoidEmptyDecimals: ''
},
{
  name: 'soloNumeros',
  symbol: '',
  thousandsSeparator: '.',
  fractionCount: 0,
  fractionSeparator: ',',
  symbolPosition: 'back',
  symbolSpacing: false,
  avoidEmptyDecimals: undefined,
},
{
name: 'dosDecimales',
symbol: '$',
thousandsSeparator: '.',
fractionCount: 2,
fractionSeparator: ',',
symbolPosition: 'front',
symbolSpacing: false,
avoidEmptyDecimals: undefined,
},]
)

/* Tabla*/
import Tabl from 'ant-design-vue/lib/table';
import Icon from 'ant-design-vue/lib/icon';
import Dropdown from 'ant-design-vue/lib/dropdown';
import Menu from 'ant-design-vue/lib/menu';
import Badge from 'ant-design-vue/lib/badge';

import 'ant-design-vue/dist/antd.css';

import VueObserveVisibility from 'vue-observe-visibility'

Vue.use(VueObserveVisibility)

Vue.component(Tabl.name, Tabl);
Vue.component(Icon.name, Icon);
Vue.component(Dropdown.name, Dropdown);
Vue.component(Menu.name, Menu);
Vue.component(Badge.name, Badge);

/* fin tabla*/


import VueTippy, { TippyComponent } from "vue-tippy";

Vue.use(VueTippy, {
  directive: "tippy", // => v-tippy
  flipDuration: 0,
  popperOptions: {
    modifiers: {
      preventOverflow: {
        enabled: true,
      }
    }
  }
});

import { tippy } from "vue-tippy";

Vue.use(tippy);
Vue.component("tippy", TippyComponent);
import "tippy.js/themes/light.css";
import "tippy.js/themes/light-border.css";
import "tippy.js/themes/google.css";
import "tippy.js/themes/translucent.css";



import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css' //Vuesax styles
Vue.use(Vuesax)

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import 'ag-grid-enterprise';


import ProgressBar from 'vuejs-progress-bar'
Vue.use(ProgressBar)

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)



Vue.filter('prettyBytes', function (num) {
  // jacked from: https://github.com/sindresorhus/pretty-bytes
  if (typeof num !== 'number' || isNaN(num)) {
    throw new TypeError('Expected a number');
  }

  var exponent;
  var unit;
  var neg = num < 0;
  var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  if (neg) {
    num = -num;
  }

  if (num < 1) {
    return (neg ? '-' : '') + num + ' B';
  }

  exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1);
  num = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
  unit = units[exponent];

  return (neg ? '-' : '') + num + ' ' + unit;
});

/**
 * 
 * @param {int} tipo "1-success, 2-warning, 3-error, (Cualquier Otro)-info" 
 * @param {string} mensaje "Mensaje de la notificacion"
 */
Vue.prototype.mostrarNotificaciones = function (tipo, mensaje, position) {
  var propiedadesNotificaciones = {timer: 10, position:"bottomRight"}
  if(tipo == 1){
    this.$notification.success(mensaje, propiedadesNotificaciones);
  }
  else if(tipo == 3){
    this.$notification.error(mensaje, propiedadesNotificaciones);
  }
  else if(tipo == 2){
    this.$notification.warning(mensaje, propiedadesNotificaciones);
  }
  else{
    this.$notification.dark(mensaje, propiedadesNotificaciones);
  }             
}

Vue.prototype.mostrarNotificaciones2 = function (tipo, titulo, mensaje, position) {
  let color = "primary"
  if(tipo == 1){
    color = "success"
  } else if(tipo == 3){
    color = "danger"
  }
  else if(tipo == 2){
    color = "warning"
  }
  else{
    color = "#0b7689"
  }


  this.$vs.notification({
    sticky: true,
    duratio: 10000,
    progress: 'auto',
    width: 'auto',
    //flat: true,
    color: color,
    position: position,
    //title: titulo,
    text: mensaje
  })
}

Vue.prototype.getBaseTippy = function(mensaje) {
    return { placement: 'top',arrow: true, animation:'perspective', theme: 'google', followCursor : true, content: mensaje}
}

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
